import Splide from '@splidejs/splide';

const sliders = document.querySelectorAll('.brand-slider__slider');

sliders.forEach(slider => {
    const splide = new Splide(slider, {
        perPage: 2,
        perMove: 1,
        gap: '2rem',
        arrows: true,
        pagination: false,
        type: 'loop',
        classes: {
            arrows: 'brand-slider__arrows',
            arrow: 'brand-slider__arrow',
            prev: 'brand-slider__arrow--prev',
            next: 'brand-slider__arrow--next',
        },
        breakpoints: {
            768: {
                perPage: 1,
                gap: '1rem',
            },
        },
    }).mount();
});
